import { inject } from "@angular/core";
import { CanMatchFn } from "@angular/router";

import { OptimizedIdCardRouteDecision } from "./optimized-id-card-route-decision.service";

/** Selects the optimized lazy module from the ready startup feature value. */
export const optimizedIdCardCanMatchGuard: CanMatchFn = () =>
  inject(OptimizedIdCardRouteDecision).resolve$();
